// Shared centered card for login / register / forgot.
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BgPhotos } from "../../components/BgPhotos";
import { LangThemeControls } from "../../components/LangThemeControls";

export function AuthShell({ title, children }: { title: string; children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-full flex flex-col">
      {/* No [data-bg] zones here — the layer shows the default "energy" photo. */}
      <BgPhotos />
      <header className="p-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo-color.png" alt="" className="h-7 w-auto" />
          <span className="font-semibold">{t("common.appName")}</span>
        </Link>
        <LangThemeControls />
      </header>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="card p-6 w-full max-w-sm">
          <h1 className="text-lg font-semibold mb-4">{title}</h1>
          {children}
        </div>
      </div>
    </div>
  );
}
